var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFileAttachmentLibrary = function SvgFileAttachmentLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.976 1.3a.2.2 0 0 0-.2.201l.09 12.958a.3.3 0 1 1-.6.005L.177 1.506A.8.8 0 0 1 .976.7H7.74a.8.8 0 0 1 .69.396l.655 1.12a.2.2 0 0 0 .173.1h4.88a.8.8 0 0 1 .8.8v1.222a.3.3 0 1 1-.6 0V3.115a.2.2 0 0 0-.2-.2h-4.88a.8.8 0 0 1-.69-.396L7.913 1.4A.2.2 0 0 0 7.74 1.3H.976Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.81 4.83H2.728a.4.4 0 0 0-.394.332L.797 13.93a.4.4 0 0 0 .394.469h13.08a.4.4 0 0 0 .394-.33l1.538-8.77a.4.4 0 0 0-.394-.47Zm-13.081-.6a1 1 0 0 0-.985.828l-1.538 8.77A1 1 0 0 0 1.19 15h13.08a1 1 0 0 0 .985-.827l1.538-8.77a1 1 0 0 0-.985-1.172H2.73Z",
    fill: "#484848"
  })));
};
export default SvgFileAttachmentLibrary;